import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "biz360_cookie_consent"; // values: "accepted" | "rejected"

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      setVisible(true);
    } else if (stored === "accepted" && typeof window.biz360LoadAnalytics === "function") {
      window.biz360LoadAnalytics();
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    if (typeof window.biz360LoadAnalytics === "function") {
      window.biz360LoadAnalytics();
    }
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(STORAGE_KEY, "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Consentement aux cookies"
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[9999] bg-white border-t shadow-2xl"
      style={{ borderTopColor: "#210875", borderTopWidth: 3 }}
    >
      <div className="max-w-5xl mx-auto px-4 py-4 flex flex-col md:flex-row md:items-center gap-3">
        <div className="flex-1 text-sm text-gray-700">
          <p className="font-semibold mb-1" style={{ color: "#210875" }}>
            🍪 Biz360 utilise des cookies
          </p>
          <p>
            Cookies essentiels (authentification) toujours actifs. Les cookies de mesure d'audience
            et de publicité (Meta Pixel, PostHog) ne sont activés qu'avec votre consentement.{" "}
            <Link
              to="/politique-confidentialite"
              className="underline hover:no-underline"
              style={{ color: "#210875" }}
              data-testid="cookie-banner-policy-link"
            >
              En savoir plus
            </Link>
          </p>
        </div>
        <div className="flex gap-2 flex-shrink-0">
          <button
            type="button"
            onClick={handleReject}
            className="px-4 py-2 text-sm rounded-md border border-gray-300 hover:bg-gray-50 transition"
            data-testid="cookie-reject-btn"
          >
            Tout refuser
          </button>
          <button
            type="button"
            onClick={handleAccept}
            className="px-4 py-2 text-sm rounded-md text-white font-semibold transition hover:opacity-90"
            style={{ backgroundColor: "#210875" }}
            data-testid="cookie-accept-btn"
          >
            Tout accepter
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
